import React from "react";

export const Header = () => {
  return (

    <section className="section main-banner" id="top" data-section="section1">
      <video autoPlay muted loop id="bg-video">
        <source src="assets/images/course-video.mp4" type="video/mp4" />
      </video>
      <div className="video-overlay header-text">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="caption">
                <h2>Создай пространство мечты</h2>
                <h6>Где каждая деталь будет отражать твою индивидуальность</h6>
                <div className="main-button-yellow">
                  <div className="scroll-to-section"><a href="#contact">Напиши нам!</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
};